import Typography from 'antd/lib/typography'

import 'antd/lib/typography/style'

export * from 'antd/lib/typography'

export default Typography
